<template>
  <v-app>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="selectedMonth"
                label="Select Month"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="selectedMonth"
              type="month"
              @change="fetchWeekData"
              no-title
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-data-table
        hide-default-footer
        :headers="headers"
        :items="[...tableData, totalRow]"
        class="elevation-1"
      ></v-data-table>
      <br>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="inputNumber"
            label="Enter Budget Amount"
            type="number"
            outlined
          ></v-text-field>
          <v-btn @click="calculateRevenueRatio">Calculate Revenue Ratio</v-btn>
          <div v-if="revenueRatio !== null">
            <h3>Revenue Ratio: {{ revenueRatio }}%</h3>
          </div>
        </v-col>
        <v-col cols="12">
          <h3>Appointments to Presentations Ratio: {{ appointmentsToPresentationsRatio }}%</h3>
        </v-col>
        <v-col cols="12">
          <h3>Presentations to Sales Ratio: {{ presentationsToSalesRatio }}%</h3>
        </v-col>
        <v-col cols="12">
          <h3>Calls to Appointments Ratio: {{ callsToAppointmentsRatio }}%</h3>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { axios } from '../../../utils';

export default {
  data() {
    return {
      menu: false,
      selectedMonth: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().substr(0, 7), // Previous month
      inputNumber: 40000,
      revenueRatio: null,
      appointmentsToPresentationsRatio: null,
      presentationsToSalesRatio: null,
      callsToAppointmentsRatio: null,
      headers: [
        { text: 'Employee Name', value: 'employee_name' }, // Change to employee_name
        { text: 'Calls', value: 'total_calls' },
        { text: 'Appointments', value: 'total_appointments' },
        { text: 'Presentations', value: 'total_presentations' },
        { text: 'Sales', value: 'total_sales' },
        { text: 'Revenue', value: 'revenue' },
        ],
      tableData: [],
      totalRow: {
        employee_name: 'Total',
        total_calls: 0,
        total_appointments: 0,
        total_presentations: 0,
        total_sales: 0,
        revenue: 0,
      },
    };
  },
  methods: {
    getStartDate(year, month) {
      const firstDay = new Date(year, month, 1);
      const dayOfWeek = firstDay.getDay();
      const firstMonday = new Date(firstDay);

      // Calculate the offset to the first Monday
      const offset = (dayOfWeek === 0) ? 1 : (9 - dayOfWeek) % 7;
      firstMonday.setDate(firstDay.getDate() + offset);

      return firstMonday;
    },
    getEndDate(startOfMonth) {
      const year = startOfMonth.getFullYear();
      const month = startOfMonth.getMonth();
      const endOfMonth = new Date(year, month + 1, 0); // last day of the current month

      // Calculate the number of days to add to reach the next Sunday
      const daysUntilSunday = (7 - endOfMonth.getDay()) % 7;
      const lastDayOfWeek = new Date(endOfMonth);
      lastDayOfWeek.setDate(endOfMonth.getDate() + daysUntilSunday);

      return lastDayOfWeek;
    },
    async getEmployeesWeeklyTotals(start, end) {
  try {
    const response = await axios.get('api/admin/phone-calls/employees-weekly-totals', {
      params: { start_date: start, end_date: end },
    });
     const employeesData = Object.keys(response.data).map(employeeId => ({
          employee_name: response.data[employeeId].employee_name, // Change from 'employee_id' to 'name'
          total_calls: response.data[employeeId].total_calls,
          total_appointments: response.data[employeeId].total_appointments,
          total_presentations: response.data[employeeId].total_presentations,
          total_sales: response.data[employeeId].total_sales,
          revenue: response.data[employeeId].revenue,
        }));

    this.tableData = employeesData;
    this.calculateTotalRow();
    this.calculateRatios();
  } catch (error) {
    console.log(error);
  }
},

    calculateTotalRow() {
      this.totalRow.total_calls = this.tableData.reduce((acc, item) => acc + item.total_calls, 0);
      this.totalRow.total_appointments = this.tableData.reduce((acc, item) => acc + item.total_appointments, 0);
      this.totalRow.total_presentations = this.tableData.reduce((acc, item) => acc + item.total_presentations, 0);
      this.totalRow.total_sales = this.tableData.reduce((acc, item) => acc + item.total_sales, 0);
      this.totalRow.revenue = this.tableData.reduce((acc, item) => acc + item.revenue, 0);
    },
    calculateRatios() {
      if (this.totalRow.total_appointments) {
        this.appointmentsToPresentationsRatio = (this.totalRow.total_presentations / this.totalRow.total_appointments) * 100;
      } else {
        this.appointmentsToPresentationsRatio = null;
      }

      if (this.totalRow.total_presentations) {
        this.presentationsToSalesRatio = (this.totalRow.total_sales / this.totalRow.total_presentations) * 100;
      } else {
        this.presentationsToSalesRatio = null;
      }

      if (this.totalRow.total_calls) {
        this.callsToAppointmentsRatio = (this.totalRow.total_appointments / this.totalRow.total_calls) * 100;
      } else {
        this.callsToAppointmentsRatio = null;
      }
    },
    updateTableData() {
      const [year, month] = this.selectedMonth.split('-').map(Number);
      const startDate = this.getStartDate(year, month - 1);
      const endDate = this.getEndDate(startDate);
      const startMs = new Date(startDate).getTime();
      const endMs = new Date(endDate).getTime();

      // Calculate the difference in milliseconds
      const diffMs = endMs - startMs;

      // Convert the difference to weeks (approximated)
      const weeks = Math.round(diffMs / (1000 * 60 * 60 * 24 * 7));
      this.inputNumber = weeks * 10000;
      this.getEmployeesWeeklyTotals(startDate, endDate);
    },
    calculateRevenueRatio() {
      if (this.totalRow.revenue) {
        this.revenueRatio = (this.totalRow.revenue / this.inputNumber) * 100;
      } else {
        this.revenueRatio = null;
      }
    },
    fetchWeekData() {
      this.updateTableData();
    },
  },
  mounted() {
    this.updateTableData();
  },
};
</script>
